import { Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import PinField from "react-pin-field";

import { loginUser } from "actions/auth";
import useNotification from "hooks/useNotification";

const PinLogin = ({ user, loginType, navigatePage }) => {
	const dispatch = useDispatch();
	const { notify } = useNotification();

	const pinRef = useRef(null);

	const [isCorrectPin, setIsCorrectPin] = useState(null);

	const Login = (pin) => {
		dispatch(loginUser({ ...user, password: pin }, loginType, navigatePage, notify));
	};

	useEffect(() => {
		if (user?._id) pinRef.current[0].focus();
	}, [user, loginType]);

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
			leave="transition-opacity duration-150"
			leaveFrom="opacity-100"
			leaveTo="opacity-0"
		>
			<div className="w-full text-center text-sm text-gray-600 space-y-2">
				<p className={`font-bold text-dark-blue`}>Enter your pin</p>
				<div
					className={`flex items-center justify-center space-x-3 ${
						isCorrectPin === "invalid" && "animate-[bounce_75ms_linear_2]"
					}`}
				>
					<PinField
						className={`text-center border border-dark-blue outline-none smooth text-5xl pb-2 rounded-full text-dark-blue h-14 w-14 focus:border-2 invalid:animate-[bounce_75ms_linear_2] invalid:border-candy-red`}
						onComplete={(pin) => Login(pin)}
						onChange={() => setIsCorrectPin(null)}
						ref={pinRef}
						length={4}
						validate="0123456789"
						type="password"
						autoFocus
					/>
				</div>
				{isCorrectPin === "invalid" && (
					<p className={`text-center text-sm text-candy-red`}>The Pin you have entered is invalid!</p>
				)}
			</div>
		</Transition>
	);
};

export default PinLogin;
